import { render, staticRenderFns } from "./PdpTable.vue?vue&type=template&id=3ffbf027&scoped=true"
import script from "./PdpTable.vue?vue&type=script&lang=js"
export * from "./PdpTable.vue?vue&type=script&lang=js"
import style0 from "./PdpTable.vue?vue&type=style&index=0&id=3ffbf027&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffbf027",
  null
  
)

export default component.exports